import React, { useMemo } from 'react'
import { Divider, Space } from 'antd'
import User from '../../../../../../components/common/user/User'
import { useFetchAssignmentSharedWithQuery } from '../../../../../../store/apis/shared-assignment.api'
import { fetchAssignmentSharedWithSelectors } from '../../../../../../store/apis/utils/selectors/shared-assignment.api.selectors'
import { useParams } from 'react-router'
import { useSelector } from 'react-redux'
import textSubmissionDrawerSelectors from '../../../../../../store/selectors/text-submission-drawer.selectors'

const AssigneeList = ({ question, submission }) => {
    const { token } = useParams()
    const isQuestionExpanded = useSelector(textSubmissionDrawerSelectors.isQuestionExpanded(question.id))

    const { data: users } = useFetchAssignmentSharedWithQuery(
        { token },
        {
            selectFromResult: result => fetchAssignmentSharedWithSelectors.selectOnlyUsers(result),
        },
    )

    const assignees = useMemo(() => {
        // Get assignees from all questionRubric answers for this question
        const questionRubricAssignees = (question.questionRubrics || []).map(qr =>
            users?.find(
                user =>
                    user.id === submission?.answers?.find(answer => answer.questionRubricId === qr.id)?.assigneeId,
            ),
        )

        return questionRubricAssignees.filter(
            (assignee, index, self) => assignee && self.indexOf(assignee) === index,
        )
    }, [users, question, submission])

    if (!assignees.length || isQuestionExpanded) return null

    return (
        <Space split={<Divider type='vertical' />}>
            {assignees.map(assignee => (
                <User key={assignee.id} size='small' name={assignee.name || '...'} id={assignee.id} />
            ))}
        </Space>
    )
}

export default AssigneeList
